import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { JsonLd } from '../components/JsonLd';
import { Seo } from '../components/Seo';
import { PAGE_SEO } from '../lib/seo';
import { breadcrumbStructuredData, webPageStructuredData } from '../lib/structuredData';
import hunterDavisPhoto from '../assets/hunter_davis_photo.jpeg';
import rahmannurPhoto from '../assets/Rahmannur_Syahputra_photo.jpeg';

const SCHEMA = [
  webPageStructuredData(PAGE_SEO.team),
  breadcrumbStructuredData([{ name: 'Our team', path: PAGE_SEO.team.path }]),
];

export const TeamPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Seo {...PAGE_SEO.team} />
      <JsonLd id="centmap-team-schema" data={SCHEMA} />
      <div className="max-w-3xl mx-auto px-4 py-16">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Our Team</h1>

        <p className="text-gray-600 mb-8 leading-relaxed">
          Centmap is built by a small team passionate about helping people discover
          the best deals at bars and restaurants in their city.
        </p>

        <div className="space-y-8">
          <div className="border-b border-gray-100 pb-8">
            <div className="flex flex-col sm:flex-row gap-6 items-start">
              <div className="flex-shrink-0">
                <img
                  src={hunterDavisPhoto}
                  alt="Hunter Davis"
                  className="w-32 h-32 sm:w-40 sm:h-40 rounded-lg object-cover shadow-md"
                />
              </div>
              <div className="flex-1">
                <h2 className="text-xl font-semibold text-gray-900 mb-1">Hunter Davis</h2>
                <p className="text-gray-500 text-sm mb-1">Founder, Director</p>
                <p className="text-gray-400 text-sm">Singapore</p>
              </div>
            </div>
          </div>

          <div className="border-b border-gray-100 pb-8">
            <div className="flex flex-col md:flex-row gap-8 items-start">
              <div className="flex flex-col sm:flex-row gap-6 items-start flex-1">
                <div className="flex-shrink-0">
                  <img
                    src={rahmannurPhoto}
                    alt="Rahmannur Syahputra"
                    className="w-32 h-32 sm:w-40 sm:h-40 rounded-lg object-cover shadow-md"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h2 className="text-xl font-semibold text-gray-900 mb-1 min-h-[1.75rem]">Rahmannur Syahputra</h2>
                  <p className="text-gray-500 text-sm mb-1">Lead Developer</p>
                  <p className="text-gray-400 text-sm">Jakarta</p>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-6 items-start flex-1">
                <div className="flex-shrink-0">
                  <div className="w-32 h-32 sm:w-40 sm:h-40 rounded-lg bg-white border-4 border-black shadow-md"></div>
                </div>
                <div className="flex-1 min-w-0">
                  <h2 className="text-xl font-semibold text-gray-900 mb-1 min-h-[1.75rem]">Enigma</h2>
                  <p className="text-gray-500 text-sm mb-1">Technology Lead & All Things Consultant</p>
                  <p className="text-gray-400 text-sm">OPSEC-friendly international waters</p>
                </div>
              </div>
            </div>
          </div>

          <div className="border-b border-gray-100 pb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-2">Contact Us</h2>
            <p className="text-gray-600 leading-relaxed">
              Have questions or feedback? We'd love to hear from you. Visit our{' '}
              <Link to="/support" className="text-emerald-600 hover:text-emerald-700 underline">
                support page
              </Link>{' '}
              to get in touch.
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};
